export const USE_MOCK = (process.env.APP_USE_MOCK ?? "true") !== "false";
export const API_BASE_URL = process.env.APP_API_BASE_URL ?? "/api/v1";
